var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoryUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.7357,
    y: 1.28313,
    width: 57.2093,
    height: 57.2093,
    rx: 6.35117,
    transform: "rotate(45 41.7357 1.28313)",
    fill: "#9E9E9E",
    stroke: "#FDFFFD",
    strokeWidth: 1.81462
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6842 56.6347C62.3013 53.5184 63.2481 50.095 63.4603 46.5853C63.6869 42.837 63.0699 39.0855 61.6547 35.6072C60.2395 32.129 58.0622 29.0124 55.283 26.487C52.5038 23.9616 49.1936 22.0918 45.5961 21.0151C41.9986 19.9385 38.2054 19.6824 34.4959 20.2658C30.7863 20.8493 27.2548 22.2573 24.1615 24.3863C21.0682 26.5153 18.4917 29.311 16.6219 32.5675L24.4386 37.0555C25.6371 34.968 27.2887 33.1759 29.2716 31.8111C31.2545 30.4464 33.5183 29.5438 35.8963 29.1698C38.2742 28.7958 40.7057 28.9599 43.0118 29.6501C45.3179 30.3403 47.4399 31.5389 49.2214 33.1578C51.0029 34.7766 52.3987 36.7744 53.3058 39.0041C54.213 41.2338 54.6085 43.6385 54.4633 46.0413C54.318 48.4441 53.6357 50.7837 52.4665 52.8879C51.6955 54.2752 50.7259 55.5369 49.5919 56.6347H60.6842Z",
    fill: "url(#paint0_linear_4315_144575)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4538 58.3128C45.7575 58.3128 51.6783 52.392 51.6783 45.0883C51.6783 37.7846 45.7575 31.8638 38.4538 31.8638C31.1501 31.8638 25.2293 37.7846 25.2293 45.0883C25.2293 52.392 31.1501 58.3128 38.4538 58.3128ZM31.5504 53.9573C31.5504 53.9573 31.525 47.651 34.3056 45.2676C35.9733 43.8381 37.8727 43.446 39.8092 43.0462C41.8348 42.628 43.9012 42.2015 45.7857 40.5704C46.6325 39.8375 47.2863 38.7693 47.5392 38.3561C47.5754 38.2969 47.6034 38.2512 47.6225 38.2218C49.5814 41.3267 50.1786 49.3051 45.7857 53.2286C41.6259 56.944 35.4142 56.0748 31.5504 53.9573Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4315_144575",
    x1: 54.534,
    y1: 28.2539,
    x2: 22.6122,
    y2: 31.0619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryUnselected);
export default __webpack_public_path__ + "static/media/category-unselected.4c848bc6ba9b70d85bc5a7912b618ca4.svg";
export { ForwardRef as ReactComponent };